import { Subject } from 'rxjs/Subject';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Component, OnInit } from '@angular/core';
import { LoadingService } from '../../../../util/loader.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EmpresaService } from '../empresa.service';
import { ComparacaoPontuacaoAno } from '../../../../models/dashboard/ComparacaoPontuacaoAno';
const swal = require('sweetalert');

@Component({
  selector: 'app-modal-informacao-empresa',
  templateUrl: './modal-informacao-empresa.component.html',
  styleUrls: ['./modal-informacao-empresa.component.scss']
})
export class ModalInformacaoEmpresaComponent implements OnInit {
  valForm: FormGroup;
  public onClose: Subject<any>;
  public codigo: number;
  public record: ComparacaoPontuacaoAno;
  buttonType;
  monthNames = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun",
    "Jul", "Ago", "Set", "Out", "Nov", "Dez"];

  item = {
    descricao: '',
    id: null,
    id_registro_contato: null
  };
  splineData: any;
  splineOptions = {
    series: {
      lines: {
        show: false
      },
      points: {
        show: true,
        radius: 4
      },
      splines: {
        show: true,
        tension: 0.4,
        lineWidth: 1,
        fill: 0.5
      }
    },
    grid: {
      borderColor: '#eee',
      borderWidth: 1,
      hoverable: true,
      backgroundColor: '#fcfcfc'
    },
    tooltip: true,
    tooltipOpts: {
      content: function (label, x, y) { return x + ' : ' + y; }
    },
    xaxis: {
      tickColor: '#fcfcfc',
      mode: 'categories'
    },
    yaxis: {
      min: 0,
      max: 150, // optional: use it for a clear represetation
      tickColor: '#eee',
      // position: (app.layout.isRTL ? 'right' : 'left'),
      tickFormatter: function (v) {
        return v/* + ' visitors'*/;
      }
    },
    shadowSize: 0
  };
  nameYaer;
  constructor(fb: FormBuilder, private _bsModalRef: BsModalRef, public loader: LoadingService, public service: EmpresaService, private route: ActivatedRoute) {
    this.nameYaer = new Date().getFullYear();
  }

  public onCancel(): void {
    const output = {
      sucesso: false
    };
    this.onClose.next(output);
    this._bsModalRef.hide();
  }
  ngOnInit() {
    this.onClose = new Subject();
    if (this.record !== undefined) {
      this.loader.show('body');
      setTimeout(() => {
        this.intCharComparacaoPontuacaoEntreAnos();
      }, 1000);
    }

  }
  intCharComparacaoPontuacaoEntreAnos() {
    this.splineData = [{
      label: this.nameYaer,
      color: "#768294",
      data: []
    }, {
      label: this.nameYaer - 1,
      color: "#1f92fe",
      data: []
    }];
    if (this.record.anoAtual.length > 0) {
      this.record.anoAtual.forEach(item => {
        this.splineData[0].data.push([this.monthNames[item.mes], item.total_pontuacao]);
      });
    } else {
      this.splineData[0].data.push([1, 0]);
    }
    this.record.anoPassado.forEach(item => {
      this.splineData[1].data.push([this.monthNames[item.mes], item.total_pontuacao]);
    });
    this.loader.hide('body');
  }
}
